import React, { Component } from 'react'
import { autobind } from 'react-decoration'
import styled from 'styled-components'

const Title = styled.h4`
  font-size: 14px;
  margin: 0;
  line-height: 1.14;
  color: rgba(0, 0, 0, 0.4);
  color: ${props => props.focused && '#4a90e2'};
`

const Input = styled.input`
  height: 40px;
  width: 100%;
  outline: none;
  border: none;
  font-size: 17px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.32);
  border-bottom-color: ${props => props.focused && '#4a90e2'};
`

class TextField extends Component {
  state = { focused: false }

  @autobind
  handleChange(e) {
    const { onChange } = this.props
    const newValue = e.target.value
    onChange(newValue)
  }

  @autobind
  handleFocused() {
    this.setState(() => ({ focused: true }))
  }

  @autobind
  handleNotFocused() {
    this.setState(() => ({ focused: false }))
  }

  render() {
    const { title, password, onChange, onFocus, onBlur, ...rest } = this.props
    const { focused } = this.state

    return (
      <div>
        <Title focused={focused}>
          {title}
        </Title>
        <Input
          type={password ? 'password' : 'text'}
          focused={focused}
          onChange={this.handleChange}
          onFocus={this.handleFocused}
          onBlur={this.handleNotFocused}
          {...rest}
        />
      </div>
    )
  }
}

export default TextField



// WEBPACK FOOTER //
// ./src/components/textField/index.js